<template lang="html">
    <section class="order-deleted">
        <h1 class="order-deleted-title">{{ $t("orders.title") }} {{ orderData.reference }}</h1>
        <div class="order-deleted-content">
            <h2>{{ $t("orders.deleteOrder.hasDeleted") }}</h2>
            <div>
                <router-link to="/" exact class="btn btn-client2">{{ $t("orders.deleteOrder.btnListOrder") }}</router-link>
            </div>
        </div>
    </section>
</template>

<script lang="js">
  export default  {
    name: 'order-deleted',
    props: ["orderData"],
    mounted() {

    },
    data() {
      return {

      }
    },
    methods: {

    },
    computed: {

    }
}
</script>

<style scoped lang="scss">
@import "../../../assets/css/themes.scss";
.order-deleted {
    @extend %primary-text;
    &-title {
        font-size: 25px;
        font-family: "oswald-regular", sans-serif;
        font-weight: bold;
        margin: 0;
        text-transform: uppercase;
    }
    &-content {
        text-align: center;
        h2 {
            font-size: 20px;
            font-family: "oswald-regular", sans-serif;
            font-weight: normal;
            margin: 20px 0;
            text-transform: uppercase;
        }
    }
}
</style>



// WEBPACK FOOTER //
// OrderDeleted.vue?32565ce6